import React, { useState } from 'react';

import Button from '@material-ui/core/Button';
import Dialog, { DialogProps } from '@material-ui/core/Dialog';
import MuiDialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import MuiDialogTitle from '@material-ui/core/DialogTitle';
import Radio from '@material-ui/core/Radio';
import RadioGroup from '@material-ui/core/RadioGroup';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import { makeStyles, withStyles } from '@material-ui/core/styles';

const DialogTitle = withStyles((theme) => ({
  root: {
    paddingTop: theme.spacing(3),
    paddingBottom: theme.spacing(),
  },
}))(MuiDialogTitle);

const DialogActions = withStyles((theme) => ({
  root: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-around',
    paddingLeft: theme.spacing(),
    paddingRight: theme.spacing(),
    paddingBottom: theme.spacing(),
  },
}))(MuiDialogActions);

const useStyles = makeStyles((theme) => ({
  content: {
    width: 325,
    padding: theme.spacing(),
  },
  field: {
    display: 'flex',
    flexDirection: 'row',
    marginBottom: theme.spacing(),
  },
  label: {
    width: 130,
  },
  description: {
    color: theme.palette.common.black,
  },
}));

type Props = Pick<DialogProps, 'open' | 'onClose'> & {
  confirmButtonText?: string;
  cancelButtonText?: string;
  title: string;
  onConfirm: (selectedMemberId: string) => void;
  onCancel?: () => void;
  contentText: string;
  memberList: {
    id: string;
    name: string;
    email: string;
    mobileNum: string;
  }[];
};

export default function AlertDifferentMemberDialog({
  cancelButtonText,
  confirmButtonText,
  onClose,
  onCancel,
  onConfirm,
  open,
  title,
  contentText,
  memberList,
}: Props) {
  const classes = useStyles();
  const [selectedMemberId, setSelectedMemberId] = useState('');

  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setSelectedMemberId((event.target as HTMLInputElement).value);
  };

  const handleSubmit = () => {
    if (selectedMemberId.length > 0) {
      onConfirm(selectedMemberId);
    }
  };

  return (
    <Dialog open={open} onClose={onClose}>
      <div className={classes.content}>
        <DialogTitle>{title}</DialogTitle>
        <DialogContent>
          <DialogContentText className={classes.description}>
            {contentText}
          </DialogContentText>
          <RadioGroup
            name="selected-member"
            value={selectedMemberId}
            onChange={handleChange}
          >
            {memberList.map((member) => {
              const label =
                member.email && member.mobileNum
                  ? member.name + ' ' + member.email + ' ' + member.mobileNum
                  : !member.email && member.mobileNum
                  ? member.name + ' ' + member.mobileNum
                  : member.email && !member.mobileNum
                  ? member.name + ' ' + member.email
                  : member.name;

              return (
                <div className={classes.field}>
                  <FormControlLabel
                    key={member.id}
                    value={member.id}
                    control={<Radio color="primary" />}
                    label={label}
                    className={classes.label}
                  />
                </div>
              );
            })}
          </RadioGroup>
        </DialogContent>
        <DialogActions>
          {cancelButtonText && onCancel && (
            <Button onClick={onCancel} variant="contained" autoFocus>
              {cancelButtonText}
            </Button>
          )}
          <Button
            onClick={handleSubmit}
            color="primary"
            autoFocus
            disabled={selectedMemberId.length === 0}
          >
            {confirmButtonText || 'Confirm'}
          </Button>
        </DialogActions>
      </div>
    </Dialog>
  );
}
